import React from "react";
import { Box } from '@curves/ui-base';
import { AnalysisResultBox } from "../Common";
import CIDBalanceCards from "./CIDBalanceCards";
import CIDBalanceBarItems from "./CIDBalanceBarItems";

const CIDBalanceSection = ({ sourceData, onTrendLineClick }) => {
	return (
		<>
			<CIDBalanceCards sourceData={sourceData} onTrendLineClick={onTrendLineClick} />
			{sourceData?.cidBodyShapeStyleText && (
				<Box className="measurement-group-content">
					<CIDBalanceBarItems sourceData={sourceData} />
					<Box className="px-1">
						<AnalysisResultBox className="measurement-group-content__item" Tip={sourceData?.cidBodyShapeTip} Desc={sourceData?.cidBodyShapeDesc} />
					</Box>
				</Box>
			)}
		</>
	);
};

export default CIDBalanceSection;
